export default __webpack_public_path__ + "static/media/ume-Instructors.4f1a62e8.png";